import { t } from "@/i18n-js/instance";

import { ContactSupport } from "../ContactSupport";

const i18nRoot = "pricing_plans.upgrade_modal";

export const ErrorRoute = () => (
  <ContactSupport title={t([i18nRoot, "errors.general_error.title"])} />
);
